import React, { useState, useEffect } from 'react';
import { PageView } from 'app/views';
import { usePage } from 'app/hooks';

import styles from './GalleryOverlay.module.scss';

const GalleryOverlay = () => {
  const page = usePage();
  const [show, setShow] = useState(false);

  useEffect(() => {
    switch (page.status) {
      case PageView.LOADING:
        setShow(true);
        break;
      case PageView.LOADED:
        setShow(false);
        break;
      default:
        break;
    }
  }, [page.status]);

  return show ? (
    <div
      className={styles.container}
      data-testid="gallery-overlay-container"
    />
  ) : null;
};

export default GalleryOverlay;
